import React from "react"

function Checkbox({
  name,
  value = undefined,
  checked,
  onChange,
  disabled = false,
  classNames = "",
  children,
}) {
  return (
    <div className={`form-check ${classNames}`}>
      <label className="form-check-label">
        {children}
        <input
          name={name}
          className="form-check-input"
          type="checkbox"
          value={value || checked}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <span className="form-check-sign" />
      </label>
    </div>
  )
}

export default Checkbox
